import { object, string } from 'yup';
import { CreateCommand } from '../../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../../enums.js';

const SCHEMA = object({
  id: string().required(),
});

/**
 * MySpaceMyReviewsCreateEvent
 *
 * - Evento emitido quando uma revisão é criada e deve ser adicionada ao meu espaço.
 */
export class MySpaceMyReviewsCreateEvent extends CreateCommand(RealtimeEventType.MySpaceMyReviewsCreate, SCHEMA) {}
